/*
 * @Author: MX
 * @Date: 2020-08-03 11:36:59
 * @LastEditTime: 2022-07-26 09:59:08
 */

// 大客户平台
export default [
  // {
  //   path: '/index',
  //   name: 'index',
  //   component: () => import(/* webpackChunkName: "VIPcustomer" */ '@views/Home.vue'),
  //   meta: { title: '首页', keepAlive: true },
  // },
  {
    path: '/singleOrder',
    name: 'singleOrder',
    component: () => import(/* webpackChunkName: "singleOrder" */ '@views/place-order/single-order/SingleOrder.vue'),
    meta: { title: '单票下单', keepAlive: true },
  },
  {
    path: '/batchOrder',
    name: 'batchOrder',
    component: () => import(/* webpackChunkName: "batchOrder" */ '@views/place-order/batch-order/BatchOrder.vue'),
    meta: { title: '批量下单', keepAlive: true },
  },
  {
    path: '/batchEntry',
    name: 'batchEntry',
    component: () => import(/* webpackChunkName: "VIPcustomer" */ '@/views/international/batch-entry/index.vue'),
    meta: { title: '进口国际件', keepAlive: true },
  },
  {
    path: '/orderList',
    name: 'orderList',
    component: () => import(/* webpackChunkName: "orderList" */ '@views/international/order-list/index.vue'),
    meta: { title: '订单列表', keepAlive: true },
  },
  {
    path: '/ExternalOrdersNo/:typeNum?',
    name: 'externalOrdersNo',
    component: () => import(/* webpackChunkName: "externalOrdersNo" */ '@views/place-order/external-order/ExternalOrdersNo.vue'),
    meta: { title: '三方下单', keepAlive: false },
  },
  {
    path: '/order/:typeNum?',
    name: 'order',
    component: () => import(/* webpackChunkName: "order" */ '@views/my-order/Order.vue'),
    meta: { title: '网页下单', keepAlive: false },
  },
  {
    path: '/externalOrders/:typeNum?',
    name: 'externalOrders',
    component: () => import(/* webpackChunkName: "externalOrders" */ '@views/my-order/ExternalOrders.vue'),
    meta: { title: '三方订单', keepAlive: false },
  },
  {
    path: '/waybill/:typeNum?',
    name: 'waybill',
    component: () => import(/* webpackChunkName: "waybill" */ '@views/my-waybill/Waybill.vue'),
    meta: { title: '我的运单', keepAlive: true },
  },
  {
    path: '/mailingAddress',
    name: 'mailingAddress',
    component: () => import(/* webpackChunkName: "mailingAddress" */ '@views/address-manage/MailingAddress.vue'),
    meta: { title: '寄件地址', keepAlive: true },
  },
  {
    path: '/receivingAddress',
    name: 'receivingAddress',
    component: () => import(/* webpackChunkName: "receivingAddress" */ '@views/address-manage/ReceivingAddress.vue'),
    meta: { title: '收件地址', keepAlive: true },
  },
  {
    path: '/returnAddress',
    name: 'returnAddress',
    component: () => import(/* webpackChunkName: "returnAddress" */ '@views/address-manage/returnAddress.vue'),
    meta: { title: '退回地址', keepAlive: true },
  },
  {
    path: '/userManage',
    name: 'userManage',
    component: () => import(/* webpackChunkName: "userManage" */ '@views/UserManage.vue'),
    meta: { title: '用户管理', keepAlive: true },
  },
  {
    path: '/expressTracking/:orderIds?',
    name: 'expressTracking',
    component: () => import(/* webpackChunkName: "expressTracking" */ '@views/service-manage/ExpressTracking.vue'),
    meta: { title: '快件跟踪', keepAlive: true },
  },
  {
    path: '/freightInquiry',
    name: 'freightInquiry',
    component: () => import(/* webpackChunkName: "freightInquiry" */ '@views/service-manage/FreightInquiry.vue'),
    meta: { title: '运费查询', keepAlive: true },
  },
  {
    path: '/problemCalendar',
    name: 'problemCalendar',
    component: () => import(/* webpackChunkName: "problemCalendar" */ '@views/problem-shipment/problemCalendar.vue'),
    meta: { title: '问题件日历', keepAlive: true },
  },
  {
    path: '/problemDetail',
    name: 'problemDetail',
    component: () => import(/* webpackChunkName: "problemDetail" */ '@views/problem-shipment/problemDetail.vue'),
    meta: { title: '问题件明细', keepAlive: true },
  },
  {
    path: '/returnParcel',
    name: 'returnParcel',
    component: () => import(/* webpackChunkName: "returnParcel" */ '@views/problem-shipment/returnParcel.vue'),
    meta: { title: '退回件', keepAlive: true },
  },
  {
    path: '/problemHandling',
    name: 'ProblemHandling',
    component: () => import(/* webpackChunkName: "ProblemHandling" */ '@/views/problem-shipment/problem-handling/index.vue'),
    meta: { title: '问题件处理', keepAlive: true },
  },
  {
    path: '/outPort',
    name: 'outPort',
    component: () => import(/* webpackChunkName: "outPort" */ '@views/out-scope/outPort.vue'),
    meta: { title: '出港维度', keepAlive: true },
  },
  {
    path: '/enterPort',
    name: 'enterPort',
    component: () => import(/* webpackChunkName: "enterPort" */ '@views/out-scope/enterPort.vue'),
    meta: { title: '进港维度', keepAlive: true },
  },
  {
    path: '/detailList',
    name: 'detailList',
    component: () => import(/* webpackChunkName: "detailList" */ '@views/out-scope/DetailList.vue'),
    meta: { title: '进港详情', keepAlive: true },
  },
  {
    path: '/outDetailList',
    name: 'outDetailList',
    component: () => import(/* webpackChunkName: "outDetailList" */ '@views/out-scope/OutDetailList.vue'),
    meta: { title: '出港详情', keepAlive: true },
  },
  {
    path: '/returnsList',
    name: 'ReturnsList',
    component: () => import(/* webpackChunkName: "ReturnsList" */ '@/views/return-exchange/ReturnsList.vue'),
    meta: { title: '退货列表', keepAlive: true },
  },
  {
    path: '/exchangeList',
    name: 'ExchangeList',
    component: () => import(/* webpackChunkName: "ExchangeList" */ '@/views/return-exchange/ExchangeList.vue'),
    meta: { title: '换货列表', keepAlive: true }
  },
  {
    path: '/submitReturns/:id/:type',
    name: 'SubmitReturns',
    component: () => import(/* webpackChunkName: "SubmitReturns" */ '@/views/return-exchange/SubmitReturns.vue'),
    meta: { title: '提交退货', keepAlive: true }
  },
  {
    path: '/submitExchange/:id/:type',
    name: 'SubmitExchange',
    component: () => import(/* webpackChunkName: "SubmitExchange" */ '@/views/return-exchange/SubmitExchange.vue'),
    meta: { title: '提交换货' }
  },
  {
    path: '/batchOrderNew',
    name: 'batchOrderNew',
    component: () => import(/* webpackChunkName: "ReturnDetail" */ '@/views/international/batch-order-new/index.vue'),
    meta: { title: '出口国际件' }
  }
]
